export default __webpack_public_path__ + "static/media/eperda.62826bf0.png";